import React from 'react'
import './AboutUs.css'


class AboutUs extends React.Component {
    constructor() {
        super();
        this.state = {
        }
    }

    render() {
        return (
            <div id="aboutUsMainContainer">
                <div className='container bigBodyContainer'>
                    <div className="about-header">
                        <h1 className="about-title">About WayCup</h1>
                        <p className="about-subtitle">Our Story, Our Passion, Our Coffee</p>
                    </div>

                    <div className="hero-video-section">
                        <div className="video-container">
                            <video 
                                width={window.innerWidth < 767 ? window.innerWidth - 100 : "800"} 
                                height="450"
                                title="WayCup Story"
                                className="hero-video"
                                controls
                                poster="/images/aboutUs/image0.jpg"
                            >
                                <source src="/images/aboutUs/reel.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>

                    <div id="aboutUSContainer" className='about-content'>
                        <div className='about-section'>
                            <div className='about-image-container'>
                                <img alt="WayCup founding story" src='/images/aboutUs/image0.jpg' className="about-image" />
                                <div className="image-overlay">
                                    <span className="overlay-text">Since 2019</span>
                                </div>
                            </div>
                            <div className='about-text-container'>
                                <h3 className="section-title">Our Story</h3>
                                <div className="text-content">
                                    <p>Founded in 2019, WAY CUP started as a small roadside kiosk with a simple mission:
                                        to make quality coffee and daily essentials easily accessible for people on the go.
                                        We wanted to offer a convenient alternative to making coffee at home providing quick service without
                                        compromising on taste or quality.</p>

                                    <p>Today, WAY CUP continues to serve busy mornings and quick stops with the same dedication,
                                        delivering great coffee and grab-and-go items that fit seamlessly into your day.</p>
                                    <p className="highlight-text">WAY CUP - Coffee made simple.</p>
                                </div>
                            </div>
                        </div>

                        <div className='about-section reverse'>
                            <div className='about-image-container'>
                                <img alt="Coffee cocktails and specialty drinks" src='/images/aboutUs/image2.jpg' className="about-image" />
                                <div className="image-overlay">
                                    <span className="overlay-text">Specialty Drinks</span>
                                </div>
                            </div>
                            <div className='about-text-container'>
                                <h3 className="section-title">Coffee Cocktails</h3>
                                <div className="text-content">
                                    <p>Coffee cocktails blend the rich flavor of coffee with the bold kick of spirits. From classic Espresso Martinis to creamy Irish Coffees, these drinks are perfect for those who love their coffee with a twist. Bold, smooth, and a little adventurous — it's coffee, reimagined.</p>
                                </div>
                            </div>
                        </div>

                        <div className='about-section'>
                            <div className='about-image-container'>
                                <img alt="Espresso and coffee brewing" src='/images/aboutUs/image1.jpg' className="about-image" />
                                <div className="image-overlay">
                                    <span className="overlay-text">Perfect Brew</span>
                                </div>
                            </div>
                            <div className='about-text-container'>
                                <h3 className="section-title">Our Coffee Philosophy</h3>
                                <div className="text-content">
                                    <p>Espresso is a strong, concentrated shot made by forcing hot water through finely-ground coffee beans. It's bold and forms the base of drinks like lattes and cappuccinos.</p>
                                    <p>Coffee is brewed more slowly, offering a smoother, lighter taste — perfect for a relaxed sip.</p>
                                    <p className="highlight-text">Different styles, same great beans.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AboutUs;